export enum PaginationEnum {
    LIMIT = 'limit',
    OFFSET = 'offset',
}
